<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('ExternalEqu.id')">
                    <el-select
                      v-model="formInline.numberType"
                      style="width: 120px"
                      :placeholder="$t('common.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.number"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ExternalEqu.externalTypeStr')">
                    <el-select
                      v-model="formInline.externalType"
                      :placeholder="$t('ExternalEqu.all')"
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.id"
                        :label="item.dictValue"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('TerminalFile.simIccicd')">
                    <el-input
                      size="mini"
                      v-model="formInline.simIccicd"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('TerminalFile.deliveryTime')">
                    <el-date-picker
                      v-model="formInline.deliveryTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.search.dateSearch')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="transferTerminal"
                  >{{$t('common.btn.bind')}}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editTerminal"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteTerminal"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button type="text" @click="addTerminal">{{$t('common.btn.add')}}</el-button>
                <el-button type="text" @click="downTerminal">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="externalId"
            :label="$t('ExternalEqu.externalId')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.externalId"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="IMEI"
            :label="$t('ExternalEqu.equIMEINumber')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.IMEI"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="externalType"
            :label="$t('ExternalEqu.externalType')+':'"
            :label-width="formLabelWidth"
          >
            <el-select v-model="form.externalType" :placeholder="$t('ExternalEqu.all')" size="small">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="simIccicd"
            :label="$t('TerminalFile.simIccicd')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.simIccicd"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="deliveryTime"
            :label="$t('TerminalFile.deliveryTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.deliveryTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('ExternalEqu.remarks')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              type="textarea"
              :rows="2"
              size="small"
              v-model="form.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeTransferDia"
        class="addDialong"
        :title="$t('common.btn.bind')"
        :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :rules="TransferRules"
          ref="TransferForm"
          :model="TransferForm"
        >
          <el-form-item
            prop="externalId"
            :label="$t('ExternalEqu.externalId')+':'"
            :label-width="LabelWidth"
            class="form-btn"
          >
            <el-input
              disabled
              size="small"
              v-model="TransferForm.externalId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="carId"
            :label="$t('ExternalEqu.carId')+':'"
            :label-width="LabelWidth"
            class="form-btn"
          >
            <el-input
              size="small"
              v-model="TransferForm.carId"
              autocomplete="off"
            ></el-input>
            <el-button v-if="isShow" @click="Relieve()">{{$t('common.btn.unBind')}}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')"
            >{{$t('common.btn.cancel')}}</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitTransferForm('TransferForm')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ExternalEqu from "./ExternalEqu.js";
export default ExternalEqu;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
